import styled, { css } from 'styled-components';

interface ButtonProps {
  outlined?: boolean;
}

export const ButtonStyled = styled.button<ButtonProps>`
  align-self: flex-end;
  height: 4.8rem;
  padding: 0 2.4rem;
  border: 2px solid #057e85;
  border-radius: 8px;
  background-color: ${({ outlined }) =>
    !outlined ? '#057E85' : 'transparent'};
  color: ${({ outlined }) => (outlined ? '#057E85' : '#fff')};
  font-weight: bold;
  transition: all 200ms;

  &:disabled {
    background: #cdcdcd;
    border-color: #cdcdcd;
    cursor: not-allowed;
    color: ${({ outlined }) => (outlined ? '#989898' : '#fff')};
  }

  &:hover:not(:disabled) {
    ${({ outlined }) =>
      !outlined
        ? css`
            filter: brightness(80%);
          `
        : css`
            opacity: 0.6;
          `}
  }
`;
